import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';
import CheckRoundSVG from '../../components/SVG/CheckRoundSVG';

import portfolioMainImg from '../../assets/img/project/details.jpg';
import portfolioImg1 from '../../assets/img/project/inner-1-1.jpg';
import portfolioImg2 from '../../assets/img/project/inner-1-2.jpg';
import portfolioImg3 from '../../assets/img/project/inner-1-3.jpg';
import portfolioImg4 from '../../assets/img/project/inner-1-4.jpg';
import portfolioImg5 from '../../assets/img/project/inner-1-5.jpg';
import portfolioImg6 from '../../assets/img/project/inner-1-6.jpg';

const PortfolioDetailsMain = () => {
  // Slider Settings
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '4',
    spaceBetween: 35,
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
    navigation: {
      prevEl: '.slider-prev',
      nextEl: '.slider-next',
    },
  };

  //Portfolio slider Items
  const items = [
    {
      id: 1,
      portfolioImage: portfolioImg1,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
    {
      id: 2,
      portfolioImage: portfolioImg2,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
    {
      id: 3,
      portfolioImage: portfolioImg3,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
    {
      id: 4,
      portfolioImage: portfolioImg4,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
    {
      id: 5,
      portfolioImage: portfolioImg5,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
    {
      id: 6,
      portfolioImage: portfolioImg6,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
  ];

  return (
    <main>
      <Breadcrumb title="Portfolio Details" subTitle="Portfolio" />

      <div className="it-pro-details-area pt-120 pb-115">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="it-pro-details-wrap">
                <div className="it-pro-details-thumb">
                  <img src={portfolioMainImg} alt="" />
                </div>
                <div className="it-pro-details-info-wrap d-flex align-items-center justify-content-between mb-40">
                  <div className="it-pro-details-info-box border-style d-flex align-items-center">
                    <div className="it-pro-details-info-icon">
                      <span>
                        <svg
                          width="21"
                          height="23"
                          viewBox="0 0 21 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.4974 12.2812C7.19531 12.2812 4.50781 9.59375 4.50781 6.29166C4.50781 2.98958 7.19531 0.302078 10.4974 0.302078C13.7995 0.302078 16.487 2.98958 16.487 6.29166C16.487 9.59375 13.7995 12.2812 10.4974 12.2812ZM10.4974 1.86458C8.0599 1.86458 6.07031 3.85416 6.07031 6.29166C6.07031 8.72916 8.0599 10.7187 10.4974 10.7187C12.9349 10.7187 14.9245 8.72916 14.9245 6.29166C14.9245 3.85416 12.9349 1.86458 10.4974 1.86458Z"
                            fill="#076CEC"
                          />
                          <path
                            d="M19.4466 22.6979C19.0195 22.6979 18.6653 22.3438 18.6653 21.9167C18.6653 18.3229 14.9987 15.4063 10.4987 15.4063C5.99869 15.4063 2.33203 18.3229 2.33203 21.9167C2.33203 22.3438 1.97786 22.6979 1.55078 22.6979C1.1237 22.6979 0.769531 22.3438 0.769531 21.9167C0.769531 17.4688 5.1341 13.8438 10.4987 13.8438C15.8633 13.8438 20.2278 17.4688 20.2278 21.9167C20.2278 22.3438 19.8736 22.6979 19.4466 22.6979Z"
                            fill="#076CEC"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="it-pro-details-info-content">
                      <h6>Client name</h6>
                      <span>Joanne Johns</span>
                    </div>
                  </div>
                  <div className="it-pro-details-info-box border-style d-flex align-items-center">
                    <div className="it-pro-details-info-icon">
                      <span>
                        <svg
                          width="25"
                          height="20"
                          viewBox="0 0 25 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M22.8027 0H8.05664C6.84507 0 5.85938 0.985693 5.85938 2.19727C5.85938 3.40884 6.84507 4.39453 8.05664 4.39453H22.8027C24.0143 4.39453 25 3.40884 25 2.19727C25 0.985693 24.0143 0 22.8027 0ZM22.8027 2.92969H8.05664C7.65278 2.92969 7.32422 2.60112 7.32422 2.19727C7.32422 1.79341 7.65278 1.46484 8.05664 1.46484H22.8027C23.2066 1.46484 23.5352 1.79341 23.5352 2.19727C23.5352 2.60112 23.2066 2.92969 22.8027 2.92969Z"
                            fill="#076CEC"
                          />
                          <path
                            d="M22.8027 7.3242H8.05664C6.84507 7.3242 5.85938 8.3099 5.85938 9.52147C5.85938 10.733 6.84507 11.7187 8.05664 11.7187H22.8027C24.0143 11.7187 25 10.733 25 9.52147C25 8.3099 24.0143 7.3242 22.8027 7.3242ZM22.8027 10.2539H8.05664C7.65278 10.2539 7.32422 9.92533 7.32422 9.52147C7.32422 9.11761 7.65278 8.78905 8.05664 8.78905H22.8027C23.2066 8.78905 23.5352 9.11761 23.5352 9.52147C23.5352 9.92533 23.2066 10.2539 22.8027 10.2539Z"
                            fill="#076CEC"
                          />
                          <path
                            d="M22.8027 14.6484H8.05664C6.84507 14.6484 5.85938 15.6341 5.85938 16.8457C5.85938 18.0573 6.84507 19.043 8.05664 19.043H22.8027C24.0143 19.043 25 18.0573 25 16.8457C25 15.6341 24.0143 14.6484 22.8027 14.6484ZM22.8027 17.5781H8.05664C7.65278 17.5781 7.32422 17.2496 7.32422 16.8457C7.32422 16.4418 7.65278 16.1133 8.05664 16.1133H22.8027C23.2066 16.1133 23.5352 16.4418 23.5352 16.8457C23.5352 17.2496 23.2066 17.5781 22.8027 17.5781Z"
                            fill="#076CEC"
                          />
                          <path
                            d="M2.19727 0C0.985693 0 0 0.985693 0 2.19727C0 3.40884 0.985693 4.39453 2.19727 4.39453C3.40884 4.39453 4.39453 3.40884 4.39453 2.19727C4.39453 0.985693 3.40884 0 2.19727 0ZM2.19727 2.92969C1.79341 2.92969 1.46484 2.60112 1.46484 2.19727C1.46484 1.79341 1.79341 1.46484 2.19727 1.46484C2.60112 1.46484 2.92969 1.79341 2.92969 2.19727C2.92969 2.60112 2.60112 2.92969 2.19727 2.92969Z"
                            fill="#076CEC"
                          />
                          <path
                            d="M2.19727 7.3242C0.985693 7.3242 0 8.3099 0 9.52147C0 10.733 0.985693 11.7187 2.19727 11.7187C3.40884 11.7187 4.39453 10.733 4.39453 9.52147C4.39453 8.3099 3.40884 7.3242 2.19727 7.3242ZM2.19727 10.2539C1.79341 10.2539 1.46484 9.92533 1.46484 9.52147C1.46484 9.11761 1.79341 8.78905 2.19727 8.78905C2.60112 8.78905 2.92969 9.11761 2.92969 9.52147C2.92969 9.92533 2.60112 10.2539 2.19727 10.2539Z"
                            fill="#076CEC"
                          />
                          <path
                            d="M2.19727 14.6484C0.985693 14.6484 0 15.6341 0 16.8457C0 18.0573 0.985693 19.043 2.19727 19.043C3.40884 19.043 4.39453 18.0573 4.39453 16.8457C4.39453 15.6341 3.40884 14.6484 2.19727 14.6484ZM2.19727 17.5781C1.79341 17.5781 1.46484 17.2496 1.46484 16.8457C1.46484 16.4418 1.79341 16.1133 2.19727 16.1133C2.60112 16.1133 2.92969 16.4418 2.92969 16.8457C2.92969 17.2496 2.60112 17.5781 2.19727 17.5781Z"
                            fill="#076CEC"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="it-pro-details-info-content">
                      <h6>Categories</h6>
                      <span>Angioplasty</span>
                    </div>
                  </div>
                  <div className="it-pro-details-info-box border-style d-flex align-items-center">
                    <div className="it-pro-details-info-icon">
                      <span>
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M24.9998 2.4825C25.0013 2.14298 24.8662 1.81712 24.6248 1.57834L23.4215 0.375016C23.1838 0.134754 22.8599 -0.000287476 22.5219 4.59508e-07H22.5177C22.1819 0.000206128 21.8601 0.13533 21.6248 0.375016L16.1665 5.83329H5.41664V1.25001C5.41664 0.559624 4.85698 4.59508e-07 4.16663 4.59508e-07H3.33331C1.49323 0.00205714 0.00205668 1.49323 0 3.33331V21.7711C0.104274 23.5971 1.62523 25.0188 3.45416 24.9998H23.7498C24.4402 24.9998 24.9998 24.4402 24.9998 23.7498V7.0833C24.9998 6.39295 24.4402 5.83329 23.7498 5.83329H22.1665L24.6248 3.37497C24.864 3.13953 24.9991 2.81815 24.9998 2.4825ZM14.9082 10.4166C14.82 10.4286 14.7314 10.3976 14.6699 10.3333C14.6079 10.2716 14.5772 10.1852 14.5866 10.0983L14.7445 8.68163C14.7511 8.65201 14.7594 8.62276 14.7695 8.59414L16.4107 10.2354C16.3837 10.2412 16.3591 10.2545 16.3307 10.2579L14.9082 10.4166ZM17.0911 9.73617L15.2678 7.91243L19.8094 3.37082L21.6319 5.19288L17.0911 9.73617ZM20.3969 2.78121L21.0148 2.16371L22.8365 3.98577L22.219 4.60368L20.3969 2.78121ZM0.833326 3.33331C0.834725 1.95319 1.95319 0.834684 3.33331 0.833327H4.16663C4.39673 0.833327 4.58332 1.01987 4.58332 1.24997V17.9165C4.58332 18.1466 4.39677 18.3331 4.16663 18.3331H3.33331C2.37609 18.3329 1.46514 18.7449 0.833326 19.4639V3.33331ZM23.7498 6.66661C23.9799 6.66661 24.1665 6.85315 24.1665 7.0833V23.7498C24.1665 23.9799 23.98 24.1665 23.7498 24.1665H3.45416C2.07865 24.1896 0.92633 23.1307 0.833326 21.7582V21.6665C0.834725 20.2864 1.95319 19.1679 3.33331 19.1665H4.16663C4.85698 19.1665 5.4166 18.6069 5.4166 17.9165V6.66661H15.3332L14.3869 7.61285C14.1228 7.87314 13.9566 8.21665 13.9165 8.58533L13.7586 10.0049C13.7456 10.1434 13.7588 10.283 13.7974 10.4166H6.66661C6.43651 10.4166 6.24993 10.6031 6.24993 10.8332C6.24993 11.0633 6.43647 11.2499 6.66661 11.2499H7.91662V22.4998C7.91662 22.7299 8.10316 22.9165 8.33331 22.9165C8.56345 22.9165 8.74999 22.73 8.74999 22.4998V16.6665H13.3333V19.9998H10.4166C10.1865 19.9998 9.99996 20.1864 9.99996 20.4165C9.99996 20.6466 10.1865 20.8332 10.4166 20.8332H18.7499C19.2101 20.8332 19.5832 20.4601 19.5832 19.9998V13.7499C19.5832 13.5198 19.3967 13.3332 19.1665 13.3332C18.9364 13.3332 18.7499 13.5198 18.7499 13.7499V15.8332H8.74995V11.2499H14.8782C14.9189 11.25 14.9595 11.2478 14.9999 11.2433L16.4236 11.0812C16.785 11.0402 17.1223 10.8796 17.382 10.6249L21.3353 6.66665L23.7498 6.66661ZM18.7499 16.6665V19.9998H14.1665V16.6665H18.7499ZM24.0373 2.78413L23.4256 3.3962L21.604 1.57456L22.2161 0.962487C22.2962 0.880302 22.4059 0.833738 22.5207 0.833327C22.6375 0.833615 22.7493 0.880754 22.8311 0.964173L24.0361 2.16667C24.1199 2.24919 24.1669 2.36198 24.1665 2.47958C24.1661 2.59434 24.1196 2.70413 24.0373 2.78413Z"
                            fill="#076CEC"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="it-pro-details-info-content">
                      <h6>Project name </h6>
                      <span>Alpatad</span>
                    </div>
                  </div>
                  <div className="it-pro-details-info-box d-flex align-items-center">
                    <div className="it-pro-details-info-icon">
                      <span>
                        <svg
                          width="23"
                          height="25"
                          viewBox="0 0 23 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.2804 16.8161C17.0826 16.8161 16.0035 17.3334 15.2544 18.1562L8.51751 13.9837C8.69737 13.5233 8.79712 13.0232 8.79712 12.5C8.79712 11.9766 8.69737 11.4765 8.51751 11.0163L15.2544 6.84355C16.0035 7.66638 17.0826 8.18384 18.2804 8.18384C20.5368 8.18384 22.3725 6.34822 22.3725 4.09183C22.3725 1.83544 20.5368 0 18.2804 0C16.0241 0 14.1884 1.83563 14.1884 4.09202C14.1884 4.6152 14.2884 5.11531 14.468 5.57574L7.7313 9.74825C6.98229 8.92542 5.90311 8.40796 4.7053 8.40796C2.44891 8.40796 0.613281 10.2438 0.613281 12.5C0.613281 14.7564 2.44891 16.592 4.7053 16.592C5.90311 16.592 6.98229 16.0747 7.7313 15.2517L14.468 19.4242C14.2884 19.8846 14.1884 20.3847 14.1884 20.9081C14.1884 23.1643 16.0241 24.9999 18.2804 24.9999C20.5368 24.9999 22.3725 23.1643 22.3725 20.9081C22.3725 18.6517 20.5368 16.8161 18.2804 16.8161ZM15.6805 4.09202C15.6805 2.65846 16.8469 1.49212 18.2804 1.49212C19.714 1.49212 20.8803 2.65846 20.8803 4.09202C20.8803 5.52558 19.714 6.69192 18.2804 6.69192C16.8469 6.69192 15.6805 5.52558 15.6805 4.09202ZM4.7053 15.0999C3.27155 15.0999 2.10521 13.9335 2.10521 12.5C2.10521 11.0664 3.27155 9.90007 4.7053 9.90007C6.13886 9.90007 7.30501 11.0664 7.30501 12.5C7.30501 13.9335 6.13886 15.0999 4.7053 15.0999ZM15.6805 20.9079C15.6805 19.4744 16.8469 18.308 18.2804 18.308C19.714 18.308 20.8803 19.4744 20.8803 20.9079C20.8803 22.3415 19.714 23.5078 18.2804 23.5078C16.8469 23.5078 15.6805 22.3415 15.6805 20.9079Z"
                            fill="#076CEC"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="it-pro-details-info-content">
                      <h6>Social Share</h6>
                      <span>Fb - Be - Tw - in</span>
                    </div>
                  </div>
                  <div className="it-pro-details-info-button">
                    <a className="it-btn-theme" href="#">
                      <Button btnText="Post Comment" />
                    </a>
                  </div>
                </div>
                <div className="it-pro-details-content">
                  <h4 className="it-section-title pb-20">
                    Website Development
                  </h4>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur.
                  </p>
                  <p className="mb-45">
                    Duis ut diam quam nulla porttitor massa id. Dignissim diam
                    quis enim lobortis scelerisque fermentum dui faucibus.
                    Quisque non tellus orci ac auctor augue mauris augue. Mi
                    tempus imperdiet nulla malesuada pellentesque. Duis ut diam
                    quam nulla porttitor massa. Massa sed elementum tempus
                    egestas sed sed risus pretium quam. Eu consequat ac felis
                    donec et odio pellentesque diam. Suspendisse faucibus
                    interdum posuere lorem ipsum. Est ante in nibh mauris
                    cursus. Augue lacus viverra vitae congue eu consequat.
                    Fermentum et sollicitudin ac orci phasellus egestas tellus.
                    Est pellentesque elit ullamcorper dignissim cras. Quam lacus
                    suspendisse faucibus interdum posuere.
                  </p>
                  <div className="row">
                    <div className="col-xl-7 col-lg-7">
                      <div className="it-pro-details-left it-pro-details-list-box">
                        <h5 className="it-pro-details-title mb-15">
                          This event will allow participants to:
                        </h5>
                        <ul>
                          <li>
                            <i>
                              <CheckRoundSVG />
                            </i>
                            Business's managers, leaders
                          </li>
                          <li>
                            <i>
                              <CheckRoundSVG />
                            </i>
                            Downloadable lectures, code and design assets for
                            all projects
                          </li>
                          <li>
                            <i>
                              <CheckRoundSVG />
                            </i>
                            Anyone who is finding a chance to get the promotion
                          </li>
                          <li>
                            <i>
                              <CheckRoundSVG />
                            </i>
                            Anyone who is finding a chance to get the promotion
                          </li>
                          <li>
                            <i>
                              <CheckRoundSVG />
                            </i>
                            Downloadable lectures, code and design assets for
                            all projects
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-xl-5 col-lg-5">
                      <div className="it-pro-details-right">
                        <ul>
                          <li>
                            <div>
                              <div className="it-pro-details-right-icon">
                                <i className="fa-sharp fa-solid fa-circle-check"></i>
                                <span>Support clients</span>
                              </div>
                              <p>
                                Sed ut perspiciatis unde omnis natus voluptatem
                                accusantium doloremque laudantium, totam rem
                                aperiam inventore
                              </p>
                            </div>
                          </li>
                          <li>
                            <div>
                              <div className="it-pro-details-right-icon">
                                <i className="fa-sharp fa-solid fa-circle-check"></i>
                                <span>Solve problems</span>
                              </div>
                              <p>
                                Sed ut perspiciatis unde omnis natus voluptatem
                                accusantium doloremque laudantium, totam rem
                                aperiam inventore
                              </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <h4 className="it-pro-details-title mt-55 mb-20">
                    Content & Creation
                  </h4>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut <br /> enim ad minim veniam, quis nostrud
                    exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat. Duis aute irure dolor in <br /> reprehenderit in
                    voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                    Excepteur sint occaecat cupidatat non proident, sunt in{' '}
                    <br /> culpa qui officia deserunt mollit anim id est
                    laborum.
                  </p>
                  <div className="it-pro-details-list-wrap mt-40">
                    <h5 className="it-pro-details-title mb-20">
                      Project Requirement
                    </h5>
                    <div className="row">
                      <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="it-pro-details-list-box">
                          <ul>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              Full business control
                            </li>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              User dashboard & analytics
                            </li>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              Custom reporting
                            </li>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              Regular update monitoring
                            </li>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              24/7 priority support
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="it-pro-details-list-box d-flex justify-content-md-center align-items-center">
                          <ul>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              Full business control
                            </li>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              User dashboard & analytics
                            </li>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              Custom reporting
                            </li>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              Regular update monitoring
                            </li>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              24/7 priority support
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="it-pro-details-list-box d-flex justify-content-lg-end align-items-center">
                          <ul>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              Full business control
                            </li>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              User dashboard & analytics
                            </li>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              Custom reporting
                            </li>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              Regular update monitoring
                            </li>
                            <li>
                              <i>
                                <CheckRoundSVG />
                              </i>
                              24/7 priority support
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-project-area fix pb-120">
        <div className="container">
          <div className="it-project-title-wrap mb-65">
            <div className="row align-items-end">
              <div className="col-xl-6 col-md-6">
                <div className="it-shop-title-box">
                  <h3 className="it-section-title">Related Portfolio </h3>
                </div>
              </div>
              <div className="col-xl-6 col-md-6">
                <div className="it-shop-arrow-box text-md-start">
                  <button className="slider-prev">
                    <span>
                      <i className="fa-regular fa-angle-left"></i>
                    </span>
                  </button>
                  <button className="slider-next">
                    <span>
                      <i className="fa-regular fa-angle-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="it-shop-slider-wrap">
                <div className="swiper-container it-project-active">
                  <Swiper
                    modules={[Navigation]}
                    {...sliderOption}
                    className="swiper-wrapper"
                  >
                    {items.map((item) => (
                      <SwiperSlide key={item.id} className="swiper-slide">
                        <div className="it-portfolio-item fix p-relative">
                          <div className="it-portfolio-thumb">
                            <img src={item.portfolioImage} alt="" />
                          </div>
                          <div className="it-portfolio-content">
                            <span>{item.subtitle}</span>
                            <h4 className="it-portfolio-title">
                              <Link
                                className="hover-anim black"
                                to="/portfolio-details"
                              >
                                {item.title}
                              </Link>
                            </h4>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PortfolioDetailsMain;
